import { Dialog, DialogContent, Box, Typography, Button, Divider } from "@mui/material";
import { Download, FileInput, ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
}

const IMPACT_ITEMS = [
  "학습·검사 진행률이 실시간으로 표시되지 않습니다.",
  "학습·검사 완료 알림을 받을 수 없습니다.",
  "페이지를 벗어난 동안 진행 상태를 파악할 수 없습니다.",
];

export default function SWCertModal({ open, onClose }: Props) {
  const navigate = useNavigate();

  const handleDownload = () => {
    onClose();
    navigate("/main/setting");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "16px" } }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "14px", p: "24px 24px 20px" }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            flexShrink: 0,
            bgcolor: "#fff8e1",
            border: "0.5px solid #ffe082",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#f59f00",
          }}
        >
          <ShieldAlert size={20} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>보안 인증서 설치가 필요합니다</Typography>
          <Typography sx={{ fontSize: "12px", color: "text.secondary", mt: "3px", lineHeight: 1.55 }}>
            서비스 워커(SW)가 활성화되지 않아 일부 기능이 정상 동작하지 않을 수 있습니다.
          </Typography>
        </Box>
      </Box>

      <Divider />

      <DialogContent sx={{ p: "20px 24px", display: "flex", flexDirection: "column", gap: "14px" }}>
        {/* 영향 목록 */}
        <Box
          sx={{
            bgcolor: "#fff8e1",
            border: "0.5px solid #ffe082",
            borderRadius: "10px",
            p: "14px 16px",
            display: "flex",
            flexDirection: "column",
            gap: "9px",
          }}
        >
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              color: "#a16207",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
              mb: "2px",
            }}
          >
            인증서 미설치 시 제한되는 기능
          </Typography>
          {IMPACT_ITEMS.map((text) => (
            <Box key={text} sx={{ display: "flex", alignItems: "flex-start", gap: "9px" }}>
              <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#f59f00", flexShrink: 0, mt: "5px" }} />
              <Typography sx={{ fontSize: "12px", color: "#78350f", lineHeight: 1.55 }}>{text}</Typography>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            p: "12px 14px",
            bgcolor: "action.hover",
            border: "0.5px solid",
            borderColor: "divider",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "8px",
              flexShrink: 0,
              bgcolor: "#e3f2fd",
              border: "0.5px solid #90caf9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#1565c0",
            }}
          >
            <FileInput size={17} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>rootCA.crt</Typography>
            <Typography sx={{ fontSize: "11px", color: "text.secondary", mt: "1px" }}>
              HAIF 로컬 루트 인증서 · 다운로드 페이지로 이동합니다
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      {/* 푸터 */}
      <Divider />
      <Box sx={{ display: "flex", gap: "10px", p: "16px 24px 12px" }}>
        <Button
          id="cert-later-btn"
          fullWidth
          variant="outlined"
          color="inherit"
          onClick={onClose}
          sx={{ borderRadius: "8px", fontSize: "13px", fontWeight: 500, color: "text.secondary" }}
        >
          나중에 하기
        </Button>
        <Button
          fullWidth
          variant="contained"
          startIcon={<Download size={15} />}
          onClick={handleDownload}
          sx={{ borderRadius: "8px", fontSize: "13px", fontWeight: 500 }}
        >
          다운로드 페이지로 이동
        </Button>
      </Box>
      <Typography sx={{ fontSize: "11px", color: "text.disabled", textAlign: "center", pb: "16px" }}>
        나중에 하기를 선택해도 설정 메뉴에서 언제든 설치할 수 있습니다.
      </Typography>
    </Dialog>
  );
}
